import { Collapse, Tag } from 'antd';
import { t } from 'i18next';
import { isNil } from 'lodash';
import { observer } from 'mobx-react';
import { ToolFilled } from '@ant-design/icons';

import { token } from '@/theme';
import { Entity } from '@/comp/MapBuilder/nodes/nodeWidget/NodeWidget.types';

import LabelValue from '../LabelValue/LabelValue';
import { useLabelValueServiceInformationItemsByDeviceType } from './ServiceInfo.utils';

const ServiceInfo = observer(({ entity }: { entity: Entity }) => {
  const { nextServiceHours, connectivity } = entity;
  const labelValueServiceInformationItems = useLabelValueServiceInformationItemsByDeviceType(entity);

  if (!labelValueServiceInformationItems.length) return null;

  return (
    <Collapse
      accordion
      expandIconPosition="end"
      className="service-information-collapse"
      items={[
        {
          key: 'service-information',
          label: <span className="service-information-title">{t('serviceInformation')}</span>,
          children: (
            <div className="collapse-container">
              <div className="label-value-container service-information-container">
                {labelValueServiceInformationItems.map(item => (
                  <LabelValue
                    key={`${item.label}-${item.value}`}
                    label={item.label}
                    value={item.value}
                    unit={item.unit}
                    prefix={item.prefix}
                    isLarge
                    connectivity={connectivity}
                    displayValueByConnectivity
                  />
                ))}
              </div>
            </div>
          ),
          ...(!isNil(nextServiceHours) && {
            extra: (
              <Tag color="default" icon={<ToolFilled color={token.colorIcon} />}>
                {t('serviceDueIn', { hours: nextServiceHours })}
              </Tag>
            ),
          }),
        },
      ]}
    />
  );
});

export default ServiceInfo;
